/**
 *
 * @param obj Object
 * @returns Returns the names of the enumerable string properties and methods of an object.
 */
export function objectKeys<Obj extends object>(obj: Obj): (keyof Obj)[] {
  return Object.keys(obj) as (keyof Obj)[];
}
